import axios from "axios"
import jwt_decode from "jwt-decode"

const API_URL = process.env.VUE_APP_URL

class AuthService {
  async login(payload) {
    const authEndpoint = "/authlogin"
    const getOrgId = JSON.parse(localStorage.getItem("currentOrg")).id
    return await axios
      .post(API_URL + authEndpoint, {
        username: payload.username,
        password: payload.password,
        reset: payload.reset,
        orgId: getOrgId
      })
      .then(response => {
        // console.log("payload: " + JSON.stringify(payload));
        // console.log("authlogin: " + JSON.stringify(response.data));

        var result = JSON.stringify(response.data)
        if (result.includes("Verify Credentials")) {
          sessionStorage.setItem("rSet", true)
          return result
        } else {
          sessionStorage.setItem("rSet", false)
        }

        const token = response.data.access_token
        const decoded = jwt_decode(token)

        if (token) {
          sessionStorage.setItem("token", JSON.stringify(token))
          sessionStorage.setItem("user", JSON.stringify(decoded.username))

          sessionStorage.setItem("firstname", decoded.first_name)
          sessionStorage.setItem("lastname", decoded.last_name)
          sessionStorage.setItem("email", decoded.email)
          sessionStorage.setItem("username", decoded.email)
          sessionStorage.setItem("userID", decoded.user_id)
          sessionStorage.setItem("usertype", decoded.role)
          sessionStorage.setItem("role", decoded.role)
          sessionStorage.setItem("kioskid", decoded.kiosk_id)
          sessionStorage.setItem("userOrgID", decoded.orgID)
          sessionStorage.setItem(
            "userLocale",
            response.data.zipcode + "|" + response.data.city + "|" + response.data.state + "|" + response.data.country
          )
          sessionStorage.setItem("member_date", decoded.member_date)
          return { username: decoded.username, organizations: decoded.organizations, token: token, decoded }
        }

        return result
      })
  }

  logout() {
    sessionStorage.removeItem("user")
  }

  register(user) {
    return axios.post(API_URL + "/signup", {
      username: user.username,
      email: user.email,
      password: user.password
    })
  }
}

export default new AuthService()
